
import styles from '@/styles/productDetail/productReviews.module.scss'
import { Pagination, Select, Button } from 'antd'


export default function ReviewConfig(props: any) {
  const items = [
    {
      label: 'Date - Newest First',
      value: 'newest',
    },
    {
      label: 'Date - Oldest First',
      value: 'oldest',
    },
    {
      label: 'Rating - High to Low',
      value: 'high',
    },
    {
      label: 'Rating - Low to High',
      value: 'low',
    },
    {
      label: 'Helpfulness - Hight to Low',
      value: 'helpfulness',
    }
  ];

  return (
    <div className={styles['config']}>
      {
        props.activeTab === 0
        &&
        <div className={styles['write-box']}>
          <Button className={styles['writeBtn']} href={`/review/write-review/${props.productID}`}>Write a Review</Button>
        </div>
      }
      <Pagination defaultCurrent={props.pages} current={props.pages} pageSize={props.pageSize} total={props.total} onChange={props.onpageChange} simple />
      <div className={styles['sort']}>
        Sort by: <Select
          dropdownStyle={{ minWidth: "230px" }}
          placeholder="Choose a sort order"
          value={props.sort ? props.sort : null}
          options={items}
          bordered={false}
          onChange={props.sortChange}
        />
      </div>
    </div>
  )
}